import React from 'react';
import { Icon, Tooltip, Typography } from '@statsbomb/kitbag-components';

import { SliderSection } from '../MetricFilters/MetricFilters.styles';
import ReversibleSlider from '../ReversibleSlider/ReversibleSlider';
import {
  PLAYS_RANGE,
  PLAYS_STAT_KEY,
} from '../ScoutPlayers/ScoutPlayers.constants';
import { TooltipInline } from '../../../../components/Tooltip/Tooltip.styles';
import { useStore } from '../../../../store/useStore';

const PlaysSlider = () => {
  const selectedStats = useStore((s) => s.selectedStats);
  const metricValueChanged = useStore((s) => s.metricValueChanged);
  const removeMetric = useStore((s) => s.removeMetric);

  const backupPlaysMetric = { ...PLAYS_RANGE, value: PLAYS_RANGE.min };
  const existingPlaysMetric = selectedStats?.find(
    (m) => m.key === PLAYS_STAT_KEY
  );
  const playsMetric = existingPlaysMetric || backupPlaysMetric;

  const headerTooltip = (
    <div style={{ maxWidth: '200px' }}>
      {playsMetric?.name}
      <br />
      {playsMetric?.description}
    </div>
  );
  const formatter = (value) => value?.toFixed(0);
  const onPlaysSliderChange = (val) => {
    if (existingPlaysMetric && val === PLAYS_RANGE.min) {
      removeMetric(playsMetric);
    }
    metricValueChanged(playsMetric, val);
  };

  return (
    <SliderSection data-testid="minPlaysSliderSection">
      <Typography variant="headingSmall">
        {playsMetric.name}
        <TooltipInline>
          <Tooltip content={headerTooltip} placement="bottom-centre">
            <Icon variant="Info" size="small" colour="primary.main" title="" />
          </Tooltip>
        </TooltipInline>
      </Typography>
      <ReversibleSlider
        min={playsMetric.min}
        max={playsMetric.max}
        value={playsMetric.value}
        onValueChanged={onPlaysSliderChange}
        formatter={formatter}
        steps={PLAYS_RANGE.steps}
      />
    </SliderSection>
  );
};

export default PlaysSlider;
